import React, { useState } from "react";
import contact_us from "../../assests/img/contact-us.jpg";
import { Card, Col, Row } from "react-bootstrap";
// import sample_date from "../../assests/img/Asset 30.svg";
import map from "../../assests/img/map.png";
import clock from "../../assests/img/clock.png";
import contactUs from "../../assests/img/contact-us.png";
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
} from "@react-google-maps/api";
import { Helmet } from "react-helmet-async";

const ContactUs = () => {
  const [open, setOpen] = useState(false);

  const position = {
    lat: 30.707720417358967,
    lng: 76.68561100959779,
  };

  return (
    <>
      {/* ================= SEO META TAGS ================= */}
      <Helmet>
        <title>
          Contact Kior Healthcare Mohali, Punjab | Tricity Diagnostics
        </title>

        <meta
          name="description"
          content="Kior Healthcare is a trusted pathology lab in Punjab and certified MRI center in Mohali. Contact us to book lab tests, MRI scans, and health checkup packages."
        />

        <meta
          name="keywords"
          content="Trusted Pathology Lab in Punjab, Certified MRI Centers in Mohali, Pathology Lab Near Me, MRI Scan Mohali, Diagnostic Center Punjab"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* ================= PAGE WRAPPER ================= */}
      <section className="contact_us">
        {/* ================= BANNER ================= */}
        <img src={contact_us} alt="Contact Kior Healthcare" />

        {/* ================= INTRO CONTENT ================= */}
        <section className="contact_intro py-5">
          <div className="coustom_container">
            <h1>Contact Us – Kior Healthcare</h1>

            <p>
              Contact Kior Healthcare, a trusted diagnostic centre in Mohali,
              for reliable medical testing, advanced imaging, and convenient
              home sample collection services. Our centre has the capability to
              deliver precise diagnostic reports with our advanced technology
              and standardised quality measures. We are based in Mohali, Punjab
              and our patient centric approach means we include all the
              necessary diagnostic services in Kharar, a part of Tricity. For
              test bookings, home collection request and service inquiries, You
              May contact Kior Healthcare at our contact numbers or Email. We
              offer diagnostic services 7 days and extended hours to cater for
              more patients as well as referring doctors. We are dedicated to
              offering the safest and highest-quality diagnostics services such
              as MRI, CT Scan, Ultrasound, X-Ray and full pathology testing all
              under one roof.
            </p>

            <h2 className="mt-4">Why Choose Kior Healthcare?</h2>
            <ul>
              <li>Advanced MRI, CT Scan, X-Ray, and Ultrasound technology</li>
              <li>Accurate and timely diagnostic reports</li>
              <li>Experienced radiologists and skilled lab professionals</li>
              <li>Convenient home sample collection service</li>
              <li>Patient-focused and hygienic diagnostic environment</li>
              <li>Trusted diagnostic centre serving Mohali and Tricity</li>
            </ul>
            <p>
              Whether you are searching for Kior Healthcare reviews, home
              collection, or a trusted diagnostic partner in Mohali, our team is
              ready to assist you with professional care and support.
            </p>

            <h3 className="mt-4">Reach Out to Our Experts</h3>
            <p>
              Whether you need routine lab tests, advanced imaging, or complete
              health checkup packages, our team is always ready to assist you.
              Every test at Kior Healthcare is handled with precision and
              delivered on time.
            </p>

            <h3 className="mt-4">Book Your Appointment Online</h3>
            <p>
              Easily schedule your lab tests, MRI scans, or wellness packages
              online or via phone. Our diagnostic services are designed to
              deliver fast, accurate, and safe results.
            </p>

            <ul>
              <li>Blood Tests & Advanced Health Panels</li>
              <li>MRI & Diagnostic Imaging Services</li>
              <li>Full Body Checkups & Wellness Packages</li>
            </ul>
          </div>
        </section>

        {/* ================= CONTACT INFO CARDS ================= */}
        <div className="coustom_container pb-5">
          <Row className="gy-4">
            <Col lg={4} md={6} sm={12}>
              <Card className="h-100 shadow border-0">
                <Card.Body className="text-center">
                  <div className="card-icon">
                    <img src={map} alt="Location" />
                  </div>

                  <Card.Title className="mt-3">
                    <strong>Our Location</strong>
                  </Card.Title>
                  <Card.Text>
                    C-210 P, Phase 8-B
                    <br />
                    Industrial Area
                    <br />
                    Mohali, Punjab
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="h-100 shadow border-0">
                <Card.Body className="text-center">
                  <div className="card-icon">
                    <img src={clock} alt="Working Hours" />
                  </div>

                  <Card.Title className="mt-3 fw-bold">
                    Working Hours
                  </Card.Title>

                  <Card.Text>
                    <strong>Monday – Saturday</strong>
                    <br />
                    8:00 AM – 8:00 PM
                    <br />
                    <strong>Sunday</strong>
                    <br />
                    9:00 AM – 4:00 PM
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="h-100 shadow border-0">
                <Card.Body className="text-center">
                  <div className="card-icon">
                    <img src={contactUs} alt="Contact" />
                  </div>

                  <Card.Title className="mt-3">
                    <strong>Contact Us</strong>
                  </Card.Title>
                  <Card.Text>
                    +91 8263000004
                    <br />
                    +91 9875964159
                    <br />
                    kiorhealthcare8b@gmail.com
                  </Card.Text>
                  {/* <Card.Text>+91 9875964159</Card.Text>
                  <Card.Text>kiorhealthcare8b@gmail.com</Card.Text> */}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* ================= GOOGLE MAP ================= */}
        <div className="map_wrapper">
          <LoadScript googleMapsApiKey="AIzaSyBl2i9Wu6bJdKYrSXWA_smOVdrugLnbzo0">
            <GoogleMap
              mapContainerStyle={{
                width: "100%",
                height: "400px",
                borderRadius: "12px",
              }}
              center={position}
              zoom={18}
            >
              {/* Custom Marker */}
              <Marker
                position={position}
                onClick={() => setOpen(true)}
                // icon={{
                //   url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
                //   scaledSize: new window.google.maps.Size(50, 50),
                // }}
              />

              {/* Info Card */}
              {open && (
                <InfoWindow
                  position={position}
                  onCloseClick={() => setOpen(false)}
                >
                  <div style={{ maxWidth: "220px", fontFamily: "Arial" }}>
                    <h3 style={{ margin: "0 0 6px", color: "#0f172a" }}>
                      Kior Healthcare
                    </h3>

                    <p
                      style={{
                        margin: "0 0 8px",
                        fontSize: "13px",
                        color: "#475569",
                      }}
                    >
                      Diagnostic & Imaging Center
                      <br />
                      Mohali, Punjab
                    </p>

                    <a
                      href="https://maps.app.goo.gl/BQhRSGEqKsCjsQqw9"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "inline-block",
                        padding: "6px 12px",
                        background: "#2563eb",
                        color: "#fff",
                        borderRadius: "6px",
                        fontSize: "13px",
                        textDecoration: "none",
                      }}
                    >
                      Get Directions
                    </a>

                    <br />

                    {/* <a
                      href="https://maps.app.goo.gl/BQhRSGEqKsCjsQqw9"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "inline-block",
                        marginTop: "6px",
                        fontSize: "12px",
                        color: "#2563eb",
                        textDecoration: "underline",
                      }}
                    >
                      Get Directions
                    </a> */}
                  </div>
                </InfoWindow>
              )}
            </GoogleMap>
          </LoadScript>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
